export default "__VITE_ASSET__Bw43dYF8__"